import { Activity } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';

export function ActivityPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-foreground">Activity</h1>
        <p className="text-sm text-foreground-muted">Recent activity across your workspace</p>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Activity className="h-10 w-10" />}
          title="No activity yet"
          description="Activity from prints, filament usage, and inventory changes will appear here."
        />
      </div>
    </div>
  );
}
